import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import useCollection from './useCollection';
import '../styles/Membres.css';

const Admin = () => {
  const { items: users, loading } = useCollection('profiles', 'created_at', true);
  const [busyId, setBusyId] = useState(null);

  const updateRole = async (id, role) => {
    setBusyId(id);
    await supabase.from('profiles').update({ role }).eq('id', id);
    setBusyId(null);
  };

  const toggleApprove = async (id, currentStatus) => {
    setBusyId(id);
    await supabase.from('profiles').update({ approved: !currentStatus }).eq('id', id);
    setBusyId(null);
  };

  return (
    <div className="membres-container">
      <h2>Administration des membres</h2>
      {loading ? (
        <p>Chargement...</p>
      ) : (
        <div className="tab-content">
          <ul className="membres-feed">
            {users.map((u) => (
              <li key={u.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                <div>
                  <strong>{u.name || 'Sans nom'}</strong> ({u.email})
                  <br />
                  <small>Statut : {u.approved ? '✅ Validé' : '⏳ En attente'}</small>
                </div>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <select
                    value={u.role || 'member'}
                    disabled={busyId === u.id}
                    onChange={(e) => updateRole(u.id, e.target.value)}
                    style={{ padding: '4px 8px', borderRadius: '4px' }}
                  >
                    <option value="member">Comédien(ne)</option>
                    <option value="director">Metteuse en scène</option>
                    <option value="admin">Administrateur</option>
                  </select>

                  <button
                    className="membres-btn"
                    style={{ backgroundColor: u.approved ? '#dc3545' : '#28a745' }}
                    disabled={busyId === u.id}
                    onClick={() => toggleApprove(u.id, u.approved)}
                  >
                    {u.approved ? 'Révoquer' : 'Valider'}
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Admin;